import ReactDOM, {render} from 'react-dom';
import React, {Component} from 'react';
import Modal from 'react-modal';


class LoginPrompt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: true
    };
  }

  close() {
    ReactDOM.unmountComponentAtNode(this.props.el);
  }

  render() {
    return (
      <Modal
        className='modal'
        isOpen={this.state.modalIsOpen}>
        <h1>This requires signing up or logging into Rivet.</h1>
        <div className='modal-actions'>
          <div className='button' onClick={this.close.bind(this)}>Close</div>
          <a className='button' href='/login'>Login</a>
          <a className='button' href='/register'>Sign Up</a>
        </div>
      </Modal>
    );
  }
}

export default LoginPrompt;



// WEBPACK FOOTER //
// ./res/front/static/js/login.js